import { useThemeContext } from "@circle-react/providers";
import { useIsCustomizeCommunityAvailable } from "./useIsCustomizeCommunity";

export const useIsCustomColorTheme = () => {
  const isCustomizeCommunity = useIsCustomizeCommunityAvailable();
  const { currentTheme } = useThemeContext();
  return isCustomizeCommunity && currentTheme !== "default";
};
